import { Component, OnInit } from '@angular/core';
import { PdfMakeWrapper, Img } from 'pdfmake-wrapper';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import { Txt, Columns, Table, Ul, Ol } from 'pdfmake-wrapper';
import { AuthService } from 'src/app/services/auth.service';
@Component({
  selector: 'app-fmtdocumentofinal',
  templateUrl: './fmtdocumentofinal.component.html',
  styleUrls: ['./fmtdocumentofinal.component.scss']
})
export class FmtdocumentofinalComponent implements OnInit {

  constructor(public authService: AuthService,) { }
  raci;
  org;
  documento;sufijo_cliente;nom_cliente
  tarea=[];
  area=[];
  ht=[];
  rel_pa=[];
  img_cliente;
  ngOnInit() {
    this.img_cliente=localStorage.getItem("img_cliente")
    this.nom_cliente=localStorage.getItem("nom_cliente")
    this.sufijo_cliente=localStorage.getItem("sufijo_cliente")
    this.documento=JSON.parse(localStorage.getItem("documento"))
    this.raci=JSON.parse(localStorage.getItem("_raci"))
    this.org=JSON.parse(localStorage.getItem("_org"))
    this.ht=JSON.parse(localStorage.getItem("_ht"))
    this.Pgg4();
  }
  cliente;
  async Pgg4(){
    var im;var im2; var im3;var img_cli;
  
    await this.authService.im_b64("/api/img_b64",{id_cliente:-1})  
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        im=res.img;   
      });
      await this.authService.im_b64("/api/img_b64",{id_cliente:-2})  
      .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);  
          im2=res.img;   
        });
        await this.authService.im_b64("/api/img_b64",{id_cliente:-3})  
        .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);  
            im3=res.img;   
          });
          await this.authService.im_b64("/api/img_bsmall64",{id_cliente:localStorage.getItem("id_cliente")})  
          .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);  
              img_cli=res.img;   
            });

    const pdf = new PdfMakeWrapper(); 
    pdf.pageOrientation("portrait"); 
    
    
    
   
 
    pdf.pageMargins([35,58, 35, 35]); 
    var cliente_name=this.nom_cliente;

    
    pdf.header(function(pagenumber: number, pagecount: number) {
     if (pagenumber===1){

     }else{
      return[
      new Table([[ 
        {text:""+cliente_name,},
        {text:'ENTREGABLE DE PROCESOS Y PROCEDIMIENTOS' ,linkToPage:2},//
        {text:' GRUPO GAROCE'}
      ]]).widths([100,400, 100]).layout("noBorders").alignment("center").fontSize(9).end
    ]    
     }
    } );
      
    pdf.pageSize("letter");
    pdf.background( 
        function(currentPage) {
          if (currentPage === 1) {
              return {image: im3,width: 612,height:792 }
          } else {
              return {image: im2,width: 612,height:792}
          }
        }
         //{image: pagenumber === 1?im2:im3,  width: 612,height:792    }
         );
    var footer = (pagenumber: number, pagecount: number) => {return {alignment:"center",fontSize:12,text: pagenumber + ' de ' + pagecount}; };
    pdf.footer(footer);
    
    var year="2 0 2 2"
    for(var i=0;i<18;i++){pdf.add(new Table([[ {text: " "}  ]]).widths([300]).layout("noBorders").fontSize(9).alignment('left').end);}
      pdf.add(new Table([[  {text:""/*"E N T R E G A B L E   D E   P R O C E S O S   Y "*/} ]]).widths([540]).bold().layout("noBorders").fontSize(22).alignment('center').end);   
    pdf.add(new Table([[  {text:""/*"P R O C E D I M I E N T O S"*/} ]]).widths([540]).layout("noBorders").bold().fontSize(22).alignment('center').end);   
    for(var i=0;i<17;i++){pdf.add(new Table([[ {text: " "}  ]]).widths([300]).layout("noBorders").fontSize(6).alignment('center').end);}        
    
    pdf.add(new Table([[  {image: img_cli,width:65,height:65} ]]).widths([540]).layout("noBorders").fontSize(22).alignment('center').end);
    for(var i=0;i<3;i++){pdf.add(new Table([[ {text: " "}  ]]).widths([300]).layout("noBorders").fontSize(6).alignment('center').end);}        
    pdf.add(new Table([[  {text: this.nom_cliente} ]]).widths([540]).layout("noBorders").fontSize(12).alignment('center').end);   
    pdf.add(new Table([[  {text: year} ]]).widths([540]).bold().pageBreak("after").layout("noBorders").fontSize(22).alignment('center').end);   

    pdf.add(new Table([[ {text: "INDICE "}  ]]).bold().widths([540]).layout("noBorders").fontSize(16).alignment('center').end);        
    pdf.add(new Table([[ 
      {text: " "}, 
      {text: " "},
      {text: "Pág. "}  ]]).widths([70,400,30]).layout("noBorders").fontSize(12).alignment('left').end);      
    
    //console.log(this.org);
    //console.log(this.raci);
    //console.log(this.documento);     
    var id__=localStorage.getItem("_id_org");
    //pdf.add(new Table([[ {text:"Capítulo 1",alignment:"right"},{text:"Introducción"}  ,{text:"2"}  ]]).bold().widths([70,400,20]).layout("noBorders").fontSize(12).alignment('left').end);    
    //pdf.add(new Table([[{text:""}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    //pdf.add(new Table([[ {text:"Capítulo 2",alignment:"right"},{text:"Objetivo del Manual"} ,{text:"3"}   ]]).bold().widths([70,400,20]).layout("noBorders").fontSize(12).alignment('left').end);        
    //pdf.add(new Table([[{text:""}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    var lista=3
    var capitulo=1;
    var subcapitulo=1
    for(var i=0;i<this.org.length;i++){

      if(Number(id__)==Number(this.org[i].id_role)){
        pdf.add(new Table([[ {text:"Capítulo "+capitulo,alignment:"right"},{text:this.org[i].role_card},{text:lista}  ]]).bold().widths([70,400,20]).layout("noBorders").fontSize(12).alignment('left').end);         
        pdf.add(new Table([[{text:""}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
        subcapitulo=1
        for(var j=0;j<this.raci.length;j++){
          if(this.raci[j].id_org==this.org[i].id_role){
            pdf.add(new Table([[ 
                {text:capitulo+"."+(subcapitulo),alignment:"right" ,linkToPage:lista},
                {text:this.raci[j].descipcion,linkToPage:lista} ,
                {text:lista,linkToPage:lista} 
              ]]).widths([70,400,20]).layout("noBorders").fontSize(11).alignment('left').end);  
            lista=lista+1;
            subcapitulo=subcapitulo+1;
            pdf.add(new Table([[{text:""}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
          } 
        }  
      }
    }  
  
   
    
    /*
    pdf.add(new Table([[{text:"CAPÍTULO 1"}  ]]).pageBreak("before").widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    pdf.add(new Table([[{text:""}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    pdf.add(new Table([[{text:"INTRODUCCIÓN"}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    pdf.add(new Table([[{text:""}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    pdf.add(new Table([[{text:this.documento.c1}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    
    
    pdf.add(new Table([[{text:""}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    pdf.add(new Table([[{text:"CAPÍTULO 2"}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    pdf.add(new Table([[{text:"OBJETIVOS DEL MANUAL DE PROCESOS Y PROCEDIMIENTOS"}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);

    pdf.add(new Table([[{text:this.documento.c2}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    pdf.add(new Table([[{text:"1. OBJETIVO DEL MANUAL"}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);

    pdf.add(new Table([[{text:"2. OBJETIVOS ESPECÍFICOS"}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    
    pdf.add(new Table([[{text:"3. JUSTIFICACIÓN"}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    pdf.add(new Table([[{text:"Al identificar fallas en la operatividad, funcionalidad e indicadores que arrojaban"}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    pdf.add(new Table([[{text:"diferentes áreas de oportunidad, se optó por trabajar con todos los equipos de trabajo,"}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    pdf.add(new Table([[{text:"para que, en conjunto, se definieran y sobre todo se actualizara cada uno de los pasos"}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    pdf.add(new Table([[{text:"para un correcto “deber Ser”. "}  ]]).widths([400]).layout("noBorders").fontSize(9).alignment('left').end);
    //console.log("hoja de trabajo");      
    */    
    //console.log("compare org")    
    //console.log(this.org)
    //console.log(id__)
    var capitulo=1
    var bnracsi=false
    for(var i=0;i<this.org.length;i++){    
      if(Number(id__)==Number(this.org[i].id_role)){
        pdf.add(new Txt("").pageBreak("before").end)
        pdf.add(new Table([[ 
          {text:"Capítulo "+capitulo}  
        ]]).widths([540]).layout("noBorders").fontSize(16).alignment('center').end);  
        pdf.add(new Table([[  {text:" "}]]).widths([20]).layout("noBorders").fontSize(6).end); 
        capitulo=capitulo+1;
        for(var j=0;j<this.raci.length;j++){          
          if(this.raci[j].id_org==this.org[i].id_role){            
            if(bnracsi)pdf.add(new Txt("").pageBreak("before").end)       
            bnracsi=true  
            console.log(this.org[i].departamento);
            pdf.add(new Table([[ 
              {text:"PROCESOS DE "+(this.org[i].departamento==undefined?"":this.org[i].departamento.toUpperCase())}         
            ]]).bold().widths([540]).layout("noBorders").fontSize(14).alignment('center').end);  
            pdf.add(new Table([[  {text:" "}]]).widths([20]).layout("noBorders").fontSize(6).end); 
            pdf.add(new Table([[  {text:" "}]]).widths([20]).layout("noBorders").fontSize(6).end); 

            pdf.add(new Table([[ 
              {text:"FICHA DE DESCRIPCION DEL PROCEDIMIENTO" ,fillColor: '#ededed', color: '#000000' }         
            ]]).widths([540]).layout("noBorders").bold().fontSize(12).alignment('center').end);    

            pdf.add(new Table([[  {text:" "}]]).widths([20]).layout("noBorders").fontSize(6).end); 
            pdf.add(new Table([[ 
              {text:"",fillColor: '#ededed', color: '#000000'},
              {text:"  DEPARTAMENTO ",fillColor: '#ededed', color: '#000000'} ,
              {text:"",fillColor: '#ffffff', color: '#000000'},  
              {text:this.org[i].departamento,fillColor: '#edefff', color: '#000000'}        
            ]]).widths([5,120,4,388]).layout("noBorders").fontSize(12).alignment('left').end);    
            pdf.add(new Table([[  {text:" "}]]).widths([20]).layout("noBorders").fontSize(6).end); 
            pdf.add(new Table([[ 
              {text:"",fillColor: '#ededed', color: '#000000'},
              {text:"  CÓDIGO ",fillColor: '#ededed', color: '#000000'},
              {text:"",fillColor: '#ffffff', color: '#000000'},  
              {text:this.sufijo_cliente+"-"+this.org[i].sufijo_org+"-"+this.raci[j].sufijo,fillColor: '#ededed', color: '#000000'}         
            ]]).widths([5,120,4,388]).layout("noBorders").fontSize(12).alignment('left').end);    
            pdf.add(new Table([[  {text:" "}]]).widths([20]).layout("noBorders").fontSize(6).end); 
            pdf.add(new Table([[ 
              {text:"",fillColor: '#ededed', color: '#000000'},
              {text:"  PROCESO ",fillColor: '#ededed', color: '#000000'},
              {text:"",fillColor: '#ffffff', color: '#000000'},  
              {text:this.raci[j].descipcion,fillColor: '#ededed', color: '#000000'}        
            ]]).widths([5,120,4,388]).layout("noBorders").fontSize(12).alignment('left').end);  
            pdf.add(new Table([[  {text:" "}]]).widths([20]).layout("noBorders").fontSize(6).end);   
            pdf.add(new Table([[ 
              {text:"",fillColor: '#ededed', color: '#000000'},
              {text:"  OBJETIVO ",fillColor: '#ededed', color: '#000000'},
              {text:"",fillColor: '#ffffff', color: '#000000'},  
              {text:this.raci[j].objetivo,fillColor: '#ededed', color: '#000000'}       
            ]]).widths([5,120,4,388]).layout("noBorders").fontSize(12).alignment('left').end); 
            pdf.add(new Table([[  {text:" "}]]).widths([20]).layout("noBorders").fontSize(6).end);   

            pdf.add(new Table([[ 
              {text:"",fillColor: '#ededed', color: '#000000'},
              {text:"  INVOLUCRADOS " ,margin: [0, 20],fillColor: '#ededed', color: '#000000'},
              {text:"",fillColor: '#ffffff', color: '#000000'},  
              {text:this.raci[j].participantes,fillColor: '#ededed', color: '#000000'}        
            ]]).widths([5,120,4,388]).layout("noBorders").fontSize(12).alignment('left').end); 

            pdf.add(new Table([[  {text:" "}]]).widths([20]).layout("noBorders").fontSize(6).end);  
                        
            pdf.add(new Table([[ {text:"DESCRIPCIÓN DEL PROCEDIMIENTO ",fillColor: '#ededed', color: '#000000'}         ]]).widths([540]).layout("noBorders").fontSize(16).alignment('center').end);    
            pdf.add(new Table([[  {text:" "}]]).widths([20]).layout("noBorders").fontSize(6).end); 
            pdf.add(new Table([[ {text:this.raci[j].procedimiento==null?" ":this.raci[j].procedimiento ,fillColor: '#ededed', color: '#000000'}         ]]).widths([540]).layout("noBorders").fontSize(12).alignment('center').end);    
            
            pdf.add(new Table([[  {text:" "}]]).widths([20]).layout("noBorders").fontSize(6).end);  
            pdf.add(new Table([[  {text:" "}]]).widths([20]).layout("noBorders").fontSize(6).end);  
            pdf.add(new Table([[ {text:" Documentos de Referencia "}         ]]).widths([540]).layout("noBorders").fontSize(16).alignment('center').end);    
            pdf.add(new Table([[  {text:" "}]]).widths([20]).layout("noBorders").fontSize(6).end);  
            pdf.add(new Table([
              [ {text:" Interno ",fillColor: '#ededed', color: '#000000'},{text:" "},
                {text:" Externo ",fillColor: '#ededed', color: '#000000'},{text:" "},
                {text:" Formato de trabajo ",fillColor: '#ededed', color: '#000000'}           
              ],[
                {text:"Hojas de Trabajo",fillColor: '#ededed', color: '#000000'},{text:" "},
                {text:"",fillColor: '#ededed', color: '#000000'},{text:" "},
                {text:"",fillColor: '#ededed', color: '#000000'}
              ],[
                {text:this.raci[j].codigoht,fillColor: '#ededed', color: '#000000'},{text:" "},
                {text:this.raci[j].doc_externo,fillColor: '#ededed', color: '#000000'},
                {text:" "},
                {text:this.raci[j].doc_interno,fillColor: '#ededed', color: '#000000'}
              ]
            ]).widths([166,5,165,5,166]).layout("noBorders").fontSize(8).alignment('left').end);   
          


            pdf.add(new Table([[  {text:" "}]]).widths([20]).layout("noBorders").fontSize(6).end);  
            pdf.add(new Table([[  {text:" "}]]).widths([20]).layout("noBorders").fontSize(6).end); 
            pdf.add(new Table([[  
              {image: im,  width: 15,height:15 , link: 'https://hoshinup.garocedev.com/raci2/#/racivdoc?'+ this.raci[j].id   },
              {text:" RACSI ", link: 'https://hoshinup.garocedev.com/raci2/#/racivdoc?'+ this.raci[j].id},
              ]
              ]).widths([20,440]).layout("noBorders").fontSize(8).alignment('left').end);    
            
            //console.log(this.ht)
            console.log(this.raci[j].id)
            for(var h=0;h<this.ht.length;h++){
              if(this.ht[h].id_raci==this.raci[j].id){
                console.log("coincide--"+this.ht[h].id_raci);
                console.log(this.ht[h]);
                pdf.add(new Table([[  
                  {image: im,  width: 15,height:15 , link: 'https://hoshinup.garocedev.com/raci2/#/htvdoc?'+ this.ht[h].id_ht   },
                  {text:""+this.ht[h].codigo, link: 'https://hoshinup.garocedev.com/raci2/#/htvdoc?'+ this.ht[h].id_ht},
                  ]
                ]).widths([20,440]).layout("noBorders").fontSize(8).alignment('left').end);    
                
              }
            }
            /****  raci ****
            this.tarea=[];
            this.area=[];
          await this.authService.service("/api/get_proceso",{id_raci:this.raci[j].id})
          .then(
            data => {
              var dat = JSON.stringify(data);
              var res = JSON.parse(dat);                      
              for(var i=0;i<res.length;i++){
                //console.log(res[i]);            
                this.tarea.push( { id:res[i].id, proceso:res[i].Titulo,descripcion:res[i].Descripcion,idx:res[i].idx}
                );
              }
            },
            error => {
                var de= JSON.stringify(error);
                var di = JSON.parse(de);
            }); 
            await this.authService.service("/api/get_area",{id_raci:this.raci[j].id})
            .then(
              data => {
                var dat = JSON.stringify(data);
                var res = JSON.parse(dat);                        
                for(var k=0;k<res.length;k++){
                  
                  var tx_area= "";
                if(res[k].id_ant==0){
                  tx_area=res[k].area
                }else{
                  if(res[k].role.toString()==""){
                    tx_area=res[k].area;
                  }else{
                    tx_area=res[k].role;
                  }
                }
                  this.area.push({ id:res[k].id,
                    area:tx_area,
                    idx:res[k].idx});        
                }
              },
              error => {
                  var de= JSON.stringify(error);                                  
              });
              var twidth=3000;
              
             
              var client_name=this.nom_cliente;
              var raciname;               
              pdf.add(new Txt("R: Responsible     A: Accountable     C: Consulted     S: Support     I: Informed: ")              
              .alignment('center').color("black").bold().fontSize(16).end);  
              pdf.add(new Txt( " ").alignment('left').color("black").bold().fontSize(18).end);  
              pdf.add(new Table([             
                [{text:"Company: "+client_name}, 
                {text:"Title: "+raciname,color:"red",alignment:'right'}], 
              ]).widths([twidth/2,twidth/2]).layout('noBorders').fontSize(16).bold().alignment('left').end);
              
              var rows_=(this.tarea.length+1);
              var row_i=Math.ceil(twidth/rows_);
              var wdt_=[];
              for(var l=0;l<rows_;l++){
                wdt_.push(row_i);                  
              }
              var column1 =new Array();
              pdf.styles({
                section: {
                        }});
              column1.push({ text: 'Process',color:'#FFFFFE',fillColor:'#e8c82f'
                  ,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
              for(var l=0;l<(this.tarea.length);l++){
                //console.log(this.tarea[i]);            
                column1.push({ text: this.tarea[l].proceso,color:'#FFFFFE',fillColor:'#e8c82f',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
              }
              pdf.add(new Table([column1
              ]).widths(wdt_).decorationColor("#000000").style("section").fontSize(11).bold().alignment('left').end);
              var column2=new Array();      
              column2.push({ text: 'Department',color:"#000000",fillColor:"#cccccc",fontsize:10,borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
              for(var l=0;l<(this.tarea.length);l++){
                column2.push({ text: this.tarea[l].descripcion,color:"#FFFFFE",fillColor:"#e8c82f",borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
              }
              pdf.add(new Table( [column2     
                ]).widths(wdt_).fontSize(9).alignment('left').end);
              this.rel_pa=[];     
              await  this.authService.service("/api/get_pa_2",{id_raci:this.raci[j].id})
              .then(
                  data => {
                    var dat = JSON.stringify(data);
                    var res = JSON.parse(dat);             
                    for(var i=0;i<res.length;i++){      
                      this.rel_pa.push(
                          {id:res[i].id,
                          id_p:res[i].id_tarea,
                          id_a:res[i].id_area,
                          rol:res[i].rol,
                          c:"X"});
                    }       
                  },
                  error => {
              }); 
              
              for(var l=0;l<(this.area.length);l++){
                //console.log(this.area[j])
                var column3=new Array();      
                column3.push({ text:this.area[l].area,color:"#535442",fillColor:"#cccccc",fontSize:10 ,
                borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});
                for(var m=0;m<(this.tarea.length);m++){
                  var bnd=0;
                  var rol="";
                  for(let k=0;k<this.rel_pa.length;k++){
                    if(this.rel_pa[k].id_p==this.tarea[m].id  &&  this.rel_pa[k].id_a==this.area[l].id){
                      bnd=1;
                      rol=this.rel_pa[k].rol;           
                    }          
                  }        
                  switch (rol) {
                    case 'R':
                    case 'AR':column3.push({ text: rol,color: '#ffffff',fillColor: '#f54242',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});                
                      break;
                    case 'A':column3.push({ text: rol,color: '#3a3fd6',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});            
                      break;
                    case 'C':column3.push({ text: rol,color: '#d6733a',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});            
                      break;
                    case 'S':column3.push({ text: rol,color: '#4fd63a',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});            
                      break;
                    case 'I':column3.push({ text: rol,color: '#000000',fontSize:20,alignment:'center',borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});            
                      break;
                    default:column3.push({ text:"",borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#555555']});break;
                  }                
                }
                pdf.add(new Table(
                  [               
                    column3    
                  ]
                ).widths(wdt_).bold().alignment('left').end);
              }
        
          /* pdf.pageOrientation("landscape");           
          //console.log(wdt_);
          //console.log("wdt");
  
            
           
          //console.log(this.area.length);
         
          */

          /**** ****/
          }
        }
      }
    }
    pdf.create().download();  
    setTimeout(function(){
      window.close();
    },4000);//

  }
} 



